import yaml from 'js-yaml'
import { IMeta, IVarPrompt, ITemplate, IPolicy, IErrors, IChoice, FiledType } from './models'
import { ENCODE_PASSWORD_PREFIX } from './PasswordField'

export function parseTemplate(template: ITemplate): IMeta {

    let doc: any;

    try {
        doc = yaml.load(template.yaml)
    } catch (e: any) {
        throw Error("Ошибка YAML: " + e);
    }

    const getOrError = (doc: any, attr: string): any => {
        const res = doc[attr];
        if (res === undefined) {
            throw Error("Отсутствует необходимый элемент: " + attr);
        }
        return res
    }

    if (!doc) {
        throw Error("Пустой файл");
    }

    if (doc.length !== 1) {
        throw Error("Неверное число корневых элементов");
    }

    doc = doc[0];

    let vars_prompt: Array<IVarPrompt> = []

    for (let p of doc.vars_prompt || []) {
        const name = getOrError(p, "name");
        const varType = p["type"] || (name === "file" ? FiledType.File : FiledType.String); // Back compatibility
        vars_prompt.push({
            name: name,
            label: getOrError(p, "prompt"),
            type: varType,
            type_options: p["type_options"] || [],
            help: p["help"] || null,
            helpLink: p["help_link"] || null,
            required: p["required"] === "yes",
            private: p["private"] === "yes",
            default: p["default"] || "",
            lookup_handler: p["lookup_handler"] || "",
            lookup_label: p["lookup_label"] || "",
            choices: (p["choices"] || []).map((item: any) => {
                if (typeof item === 'string') {
                    return {
                        name: item,
                        label: item
                    } as IChoice
                } else {
                    if (typeof item !== 'object' || Object.keys(item).length !== 2 || item["label"] === undefined) {
                        throw Error("Неверный параметр choises: " + JSON.stringify(item))
                    }
                    const label = item['label'];
                    delete item['label'];
                    const name = Object.keys(item)[0]
                    return { name, label } as IChoice
                }
            })
        });
    }

    let meta: IMeta = {
        template: template.id,
        name: getOrError(doc, "name"),
        vars_prompt
    }

    return meta
}

export function validatePolicy(policy: IPolicy, meta: IMeta): IErrors {
    let res: IErrors = { fields: {}, ok: true }

    for (const prompt of meta.vars_prompt) {
        if (prompt.required) {

            let required = false;

            switch (prompt.type) {
                case FiledType.File: {
                    required = !policy.file;
                    break;
                }
                case FiledType.Password: {
                    required = !(policy.vars[prompt.name] || "").replace(ENCODE_PASSWORD_PREFIX, '');
                    break;
                }
                default: {
                    required = !policy.vars[prompt.name];
                    break;
                }
            }

            if (required) {
                res.fields[prompt.name] = "Это обязательное значение"
            }
        }
    }
    if (!policy.name) res.fields["name"] = "Задайте название политики"

    if (policy.show_in_app_store && !policy.app_name) {
        res.fields["app_name"] = "Пожалуйста, задайте название приложения или отключите отображение в \"Магазине приложений\""
    }
    res.ok = Object.keys(res.fields).length === 0;
    return res
}
